import { useState } from 'react';
import { FlaskConical, Maximize2 } from 'lucide-react';
import { AquaLabView } from './AquaLabView';

// AquaFlow tab "profile lab": short description, the lab itself opens full size
export function AquaLab(props) {
  const { t } = props, [open, setOpen] = useState(false);
  return (
    <div className="aq-lab" data-testid="lab-panel">
      <b><FlaskConical size={15} /> {t.labTitle}</b>
      <small className="muted">{t.labSide}</small>
      <small>{t.labSteps}</small>
      <button className="btn btn-accent aq-run" data-testid="lab-open" onClick={() => setOpen(true)}><Maximize2 size={16} /> {t.labOpen}</button>
      {open && <AquaLabView {...props} onClose={() => setOpen(false)} />}
    </div>
  );
}
